const presentingProblemJSON = {
  section: 'PP',
  topic: 'Presenting Problem/Primary Complaint',
  checked: 'true',
  color: 'secondary',
  description: '',
  body: [
    // {
    //   id: "PP.VTT",
    //   shortname: "pp-but-vtt",
    //   access: "private",
    //   name: "",
    //   prevalue: "",
    //   buttonname_not_recording : "🎤 Push to talk",
    //   buttonname_recording : "Listening...",
    //   value: "100",
    //   disabled: "false",
    //   type: "buttonvtt",
    //   act: "PP-BUT-VTT",
    //   depending: "",
    //   exception: "",
    //   link: "PP-TEXT-VTT",
    // },
    // {
    //   id: "PP.VTT-TEXT",
    //   shortname: "pp-text-vtt",
    //   access: "private",
    //   name: "",
    //   prevalue: "",
    //   type: "textarea",
    //   value: "",
    //   disabled: "false",
    //   act: "PP-TEXT-VTT",
    //   depending: "",
    //   exception: "",
    //   extend: "true",
    // },
    {
      id: 'PP.1',
      access: 'private',
      shortname: 'gi5',
      name: 'Assessment Date:',
      prevalue: '',
      value: '',
      disabled: 'false',
      type: 'date',
      act: 'GI5',
      mandatory: 'true',
      depending: '',
      exception: '',
    },
    {
      id: 'PP.2',
      access: 'private',
      shortname: 'gi8-vir',
      name: 'Assessment Type:',
      prevalue: '',
      value: '',
      disabled: 'false',
      type: 'radio',
      radio_options: ['Assessment', 'Reassessment'],
      act: 'GI8-VIR',
      mandatory: 'true',
      depending: '',
      exception: '',
    },
    {
      id: 'PP.3',
      shortname: 'pp1',
      name: 'What is the PRIMARY reason for your having this assessment?',
      prevalue: '',
      value: '',
      disabled: 'false',
      type: 'text',
      act: 'PP1',
      depending: '',
      exception: '',
    },
    {
      id: 'PP.4',
      shortname: 'pp-new3',
      name: 'What led you/motivated you to schedule this evaluation?',
      prevalue: '',
      value: '',
      disabled: 'false',
      type: 'text',
      act: 'PP-NEW3',
      depending: '',
      exception: '',
    },
    // {
    //   id: "PP.5",
    //   shortname: "pp7-vir",
    //   mandatory: "true",
    //   name: "Describe any issues that contribute to current problem and/or should be taken into account during treatment planning:",
    //   prevalue: "",
    //   value: "",
    //   disabled: "false",
    //   type: "editor",
    //   act: "PP7-VIR",
    //   depending: "",
    //   exception: ""
    // },

    {
      id: 'PP.5',
      shortname: 'pp5-vir-new',
      name: 'Indicate any symptoms/issues that contribute to your current problem and/or should be taken into account during treatment planning. Indicate Onset and Duration of each symptom.:',
      prevalue: '',
      value: '',
      disabled: 'false',
      type: 'subtopic',
      act: 'PP5-VIR-NEW',
      depending: '',
      exception: '',
    },
    // {
    //   id: 'PP.5.1',
    //   shortname: 'pp5-1-vir-new',
    //   name: '',
    //   prevalue: 'Aggressive Behaviors',
    //   value: [false],
    //   disabled: 'false',
    //   type: 'checkbox',
    //   radio_options: ['Impact'],
    //   act: 'PP5-1-VIR-NEW',
    //   depending: '',
    //   exception: '',
    //   link: 'PP5-1-1-VIR-NEW',
    //   subtopic_container_act: 'PP5-VIR-NEW',
    //   suptopic_code: 'PP5-VIR-NEW-SEC-1',
    //   subtopic_name: "Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted",
    // },
    // {
    //   id: "PP.5.1.1",
    //   extend: "true",
    //   shortname: "pp5-1-1-vir-new",
    //   name: "",
    //   prevalue: "Onset",
    //   value: "",
    //   disabled: "true",
    //   type: "text",
    //   act: "PP5-1-1-VIR-NEW",
    //   depending: "PP5-1-VIR-NEW",
    //   exception: "Impact",
    //   link: 'PP5-1-2-VIR-NEW',
    //   subtopic_container_act: 'PP5-VIR-NEW',
    //   suptopic_code: 'PP5-VIR-NEW-SEC-1',
    //   subtopic_name: "Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted",
    // },
    // {
    //   id: "PP.5.1.2",
    //   extend: "true",
    //   shortname: "pp5-1-2-vir-new",
    //   name: "",
    //   prevalue: "Onset",
    //   value: "",
    //   disabled: "true",
    //   type: "text",
    //   act: "PP5-1-2-VIR-NEW",
    //   depending: "PP5-1-VIR-NEW",
    //   exception: "Impact",
    //   link: 'PP5-2-VIR-NEW',
    //   subtopic_container_act: 'PP5-VIR-NEW',
    //   suptopic_code: 'PP5-VIR-NEW-SEC-1',
    //   subtopic_name: "Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted",
    // },
    // {
    //   id: 'PP.5.2',
    //   shortname: 'pp5-2-vir-new',
    //   name: '',
    //   prevalue: 'Agitation',
    //   value: [false],
    //   disabled: 'false',
    //   type: 'checkbox',
    //   radio_options: ['Impact'],
    //   act: 'PP5-2-VIR-NEW',
    //   depending: '',
    //   exception: '',
    //   link: 'PP5-2-1-VIR-NEW',
    //   subtopic_container_act: 'PP5-VIR-NEW',
    //   suptopic_code: 'PP5-VIR-NEW-SEC-1',
    //   subtopic_name: "Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted",
    // },
    // {
    //   id: "PP.5.2.1",
    //   extend: "true",
    //   shortname: "pp5-2-1-vir-new",
    //   name: "",
    //   prevalue: "Onset",
    //   value: "",
    //   disabled: "true",
    //   type: "text",
    //   act: "PP5-2-1-VIR-NEW",
    //   depending: "PP5-2-VIR-NEW",
    //   exception: "Impact",
    //   link: 'PP5-2-2-VIR-NEW',
    //   subtopic_container_act: 'PP5-VIR-NEW',
    //   suptopic_code: 'PP5-VIR-NEW-SEC-1',
    //   subtopic_name: "Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted",
    // },
    // {
    //   id: "PP.5.2.2",
    //   extend: "true",
    //   shortname: "pp5-2-2-vir-new",
    //   name: "",
    //   prevalue: "Onset",
    //   value: "",
    //   disabled: "true",
    //   type: "text",
    //   act: "PP5-2-2-VIR-NEW",
    //   depending: "PP5-2-VIR-NEW",
    //   exception: "Impact",
    //   // link: 'PP5-2-VIR-NEW',
    //   subtopic_container_act: 'PP5-VIR-NEW',
    //   suptopic_code: 'PP5-VIR-NEW-SEC-1',
    //   subtopic_name: "Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted",
    // },
    //======================================================
    {
      id: 'PP.5.1',
      shortname: 'pp5-1-vir-new',
      name: '',
      prevalue: 'Aggressive Behaviors',
      value: [false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact'],
      act: 'PP5-1-VIR-NEW',
      depending: '',
      exception: '',
      link: 'PP5-1-1-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.1.1',
      extend: 'true',
      shortname: 'pp5-1-1-vir-new',
      name: '',
      prevalue: 'Onset',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-1-1-VIR-NEW',
      depending: 'PP5-1-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-1-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.1.2',
      extend: 'true',
      shortname: 'pp5-1-2-vir-new',
      name: '',
      prevalue: 'Duration',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-1-2-VIR-NEW',
      depending: 'PP5-1-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.2',
      shortname: 'pp5-2-vir-new',
      name: '',
      prevalue: 'Agitation',
      value: [false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact'],
      act: 'PP5-2-VIR-NEW',
      depending: '',
      exception: '',
      link: 'PP5-2-1-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.2.1',
      extend: 'true',
      shortname: 'pp5-2-1-vir-new',
      name: '',
      prevalue: 'Onset',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-2-1-VIR-NEW',
      depending: 'PP5-2-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-2-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.2.2',
      extend: 'true',
      shortname: 'pp5-2-2-vir-new',
      name: '',
      prevalue: 'Duration',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-2-2-VIR-NEW',
      depending: 'PP5-2-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-3-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.3',
      shortname: 'pp5-3-vir-new',
      name: '',
      prevalue: 'Anorexia',
      value: [false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact'],
      act: 'PP5-3-VIR-NEW',
      depending: '',
      exception: '',
      link: 'PP5-3-1-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.3.1',
      extend: 'true',
      shortname: 'pp5-3-1-vir-new',
      name: '',
      prevalue: 'Onset',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-3-1-VIR-NEW',
      depending: 'PP5-3-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-3-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.3.2',
      extend: 'true',
      shortname: 'pp5-3-2-vir-new',
      name: '',
      prevalue: 'Duration',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-3-2-VIR-NEW',
      depending: 'PP5-3-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-4-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.4',
      shortname: 'pp5-4-vir-new',
      name: '',
      prevalue: 'Appetite Disturbance',
      value: [false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact'],
      act: 'PP5-4-VIR-NEW',
      depending: '',
      exception: '',
      link: 'PP5-4-1-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.4.1',
      extend: 'true',
      shortname: 'pp5-4-1-vir-new',
      name: '',
      prevalue: 'Onset',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-4-1-VIR-NEW',
      depending: 'PP5-4-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-4-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.4.2',
      extend: 'true',
      shortname: 'pp5-4-2-vir-new',
      name: '',
      prevalue: 'Duration',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-4-2-VIR-NEW',
      depending: 'PP5-4-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-5-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.5',
      shortname: 'pp5-5-vir-new',
      name: '',
      prevalue: 'Bingeing/Purging',
      value: [false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact'],
      act: 'PP5-5-VIR-NEW',
      depending: '',
      exception: '',
      link: 'PP5-5-1-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.5.1',
      extend: 'true',
      shortname: 'pp5-5-1-vir-new',
      name: '',
      prevalue: 'Onset',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-5-1-VIR-NEW',
      depending: 'PP5-5-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-5-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.5.2',
      extend: 'true',
      shortname: 'pp5-5-2-vir-new',
      name: '',
      prevalue: 'Duration',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-5-2-VIR-NEW',
      depending: 'PP5-5-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-6-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.6',
      shortname: 'pp5-6-vir-new',
      name: '',
      prevalue: 'Circumstantial Symptoms',
      value: [false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact'],
      act: 'PP5-6-VIR-NEW',
      depending: '',
      exception: '',
      link: 'PP5-6-1-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.6.1',
      extend: 'true',
      shortname: 'pp5-6-1-vir-new',
      name: '',
      prevalue: 'Onset',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-6-1-VIR-NEW',
      depending: 'PP5-6-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-6-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.6.2',
      extend: 'true',
      shortname: 'pp5-6-2-vir-new',
      name: '',
      prevalue: 'Duration',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-6-2-VIR-NEW',
      depending: 'PP5-6-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-7-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.7',
      shortname: 'pp5-7-vir-new',
      name: '',
      prevalue: 'Concomitant Medical Condition',
      value: [false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact'],
      act: 'PP5-7-VIR-NEW',
      depending: '',
      exception: '',
      link: 'PP5-7-1-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.7.1',
      extend: 'true',
      shortname: 'pp5-7-1-vir-new',
      name: '',
      prevalue: 'Onset',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-7-1-VIR-NEW',
      depending: 'PP5-7-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-7-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.7.2',
      extend: 'true',
      shortname: 'pp5-7-2-vir-new',
      name: '',
      prevalue: 'Duration',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-7-2-VIR-NEW',
      depending: 'PP5-7-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-8-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.8',
      shortname: 'pp5-8-vir-new',
      name: '',
      prevalue: 'Conduct Problems',
      value: [false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact'],
      act: 'PP5-8-VIR-NEW',
      depending: '',
      exception: '',
      link: 'PP5-8-1-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.8.1',
      extend: 'true',
      shortname: 'pp5-8-1-vir-new',
      name: '',
      prevalue: 'Onset',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-8-1-VIR-NEW',
      depending: 'PP5-8-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-8-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.8.2',
      extend: 'true',
      shortname: 'pp5-8-2-vir-new',
      name: '',
      prevalue: 'Duration',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-8-2-VIR-NEW',
      depending: 'PP5-8-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-9-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.9',
      shortname: 'pp5-9-vir-new',
      name: '',
      prevalue: 'Delusions',
      value: [false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact'],
      act: 'PP5-9-VIR-NEW',
      depending: '',
      exception: '',
      link: 'PP5-9-1-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.9.1',
      extend: 'true',
      shortname: 'pp5-9-1-vir-new',
      name: '',
      prevalue: 'Onset',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-9-1-VIR-NEW',
      depending: 'PP5-9-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-9-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.9.2',
      extend: 'true',
      shortname: 'pp5-9-2-vir-new',
      name: '',
      prevalue: 'Duration',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-9-2-VIR-NEW',
      depending: 'PP5-9-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-10-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.10',
      shortname: 'pp5-10-vir-new',
      name: '',
      prevalue: 'Depressed Mood',
      value: [false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact'],
      act: 'PP5-10-VIR-NEW',
      depending: '',
      exception: '',
      link: 'PP5-10-1-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.10.1',
      extend: 'true',
      shortname: 'pp5-10-1-vir-new',
      name: '',
      prevalue: 'Onset',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-10-1-VIR-NEW',
      depending: 'PP5-10-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-10-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.10.2',
      extend: 'true',
      shortname: 'pp5-10-2-vir-new',
      name: '',
      prevalue: 'Duration',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-10-2-VIR-NEW',
      depending: 'PP5-10-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-11-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.11',
      shortname: 'pp5-11-vir-new',
      name: '',
      prevalue: 'Dissociative States',
      value: [false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact'],
      act: 'PP5-11-VIR-NEW',
      depending: '',
      exception: '',
      link: 'PP5-11-1-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.11.1',
      extend: 'true',
      shortname: 'pp5-11-1-vir-new',
      name: '',
      prevalue: 'Onset',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-11-1-VIR-NEW',
      depending: 'PP5-11-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-11-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.11.2',
      extend: 'true',
      shortname: 'pp5-11-2-vir-new',
      name: '',
      prevalue: 'Duration',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-11-2-VIR-NEW',
      depending: 'PP5-11-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-12-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.12',
      shortname: 'pp5-12-vir-new',
      name: '',
      prevalue: 'Elevated Mood',
      value: [false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact'],
      act: 'PP5-12-VIR-NEW',
      depending: '',
      exception: '',
      link: 'PP5-12-1-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.12.1',
      extend: 'true',
      shortname: 'pp5-12-1-vir-new',
      name: '',
      prevalue: 'Onset',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-12-1-VIR-NEW',
      depending: 'PP5-12-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-12-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.12.2',
      extend: 'true',
      shortname: 'pp5-12-2-vir-new',
      name: '',
      prevalue: 'Duration',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-12-2-VIR-NEW',
      depending: 'PP5-12-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-13-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.13',
      shortname: 'pp5-13-vir-new',
      name: '',
      prevalue: 'Elimination Disturbance',
      value: [false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact'],
      act: 'PP5-13-VIR-NEW',
      depending: '',
      exception: '',
      link: 'PP5-13-1-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.13.1',
      extend: 'true',
      shortname: 'pp5-13-1-vir-new',
      name: '',
      prevalue: 'Onset',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-13-1-VIR-NEW',
      depending: 'PP5-13-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-13-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.13.2',
      extend: 'true',
      shortname: 'pp5-13-2-vir-new',
      name: '',
      prevalue: 'Duration',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-13-2-VIR-NEW',
      depending: 'PP5-13-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-14-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.14',
      shortname: 'pp5-14-vir-new',
      name: '',
      prevalue: 'Emotional Trauma-(Perpetrator)',
      value: [false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact'],
      act: 'PP5-14-VIR-NEW',
      depending: '',
      exception: '',
      link: 'PP5-14-1-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.14.1',
      extend: 'true',
      shortname: 'pp5-14-1-vir-new',
      name: '',
      prevalue: 'Onset',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-14-1-VIR-NEW',
      depending: 'PP5-14-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-14-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.14.2',
      extend: 'true',
      shortname: 'pp5-14-2-vir-new',
      name: '',
      prevalue: 'Duration',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-14-2-VIR-NEW',
      depending: 'PP5-14-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-15-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.15',
      shortname: 'pp5-15-vir-new',
      name: '',
      prevalue: 'Emotional Trauma-(Victim)',
      value: [false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact'],
      act: 'PP5-15-VIR-NEW',
      depending: '',
      exception: '',
      link: 'PP5-15-1-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.15.1',
      extend: 'true',
      shortname: 'pp5-15-1-vir-new',
      name: '',
      prevalue: 'Onset',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-15-1-VIR-NEW',
      depending: 'PP5-15-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-15-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.15.2',
      extend: 'true',
      shortname: 'pp5-15-2-vir-new',
      name: '',
      prevalue: 'Duration',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-15-2-VIR-NEW',
      depending: 'PP5-15-VIR-NEW',
      exception: 'Impact',
      // link: 'PP5-16-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.16',
      shortname: 'pp5-16-vir-new',
      name: '',
      prevalue: 'Emotionality',
      value: [false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact'],
      act: 'PP5-16-VIR-NEW',
      depending: '',
      exception: '',
      link: 'PP5-16-1-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.16.1',
      extend: 'true',
      shortname: 'pp5-16-1-vir-new',
      name: '',
      prevalue: 'Onset',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-16-1-VIR-NEW',
      depending: 'PP5-16-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-16-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.16.2',
      extend: 'true',
      shortname: 'pp5-16-2-vir-new',
      name: '',
      prevalue: 'Duration',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-16-2-VIR-NEW',
      depending: 'PP5-16-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-17-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.17',
      shortname: 'pp5-17-vir-new',
      name: '',
      prevalue: 'Fatigue/Low Energy',
      value: [false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact'],
      act: 'PP5-17-VIR-NEW',
      depending: '',
      exception: '',
      link: 'PP5-17-1-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.17.1',
      extend: 'true',
      shortname: 'pp5-17-1-vir-new',
      name: '',
      prevalue: 'Onset',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-17-1-VIR-NEW',
      depending: 'PP5-17-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-17-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.17.2',
      extend: 'true',
      shortname: 'pp5-17-2-vir-new',
      name: '',
      prevalue: 'Duration',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-17-2-VIR-NEW',
      depending: 'PP5-17-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-18-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.18',
      shortname: 'pp5-18-vir-new',
      name: '',
      prevalue: 'Generalized Anxiety',
      value: [false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact'],
      act: 'PP5-18-VIR-NEW',
      depending: '',
      exception: '',
      link: 'PP5-18-1-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.18.1',
      extend: 'true',
      shortname: 'pp5-18-1-vir-new',
      name: '',
      prevalue: 'Onset',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-18-1-VIR-NEW',
      depending: 'PP5-18-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-18-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.18.2',
      extend: 'true',
      shortname: 'pp5-18-2-vir-new',
      name: '',
      prevalue: 'Duration',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-18-2-VIR-NEW',
      depending: 'PP5-18-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-19-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.19',
      shortname: 'pp5-19-vir-new',
      name: '',
      prevalue: 'Grief',
      value: [false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact'],
      act: 'PP5-19-VIR-NEW',
      depending: '',
      exception: '',
      link: 'PP5-19-1-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.19.1',
      extend: 'true',
      shortname: 'pp5-19-1-vir-new',
      name: '',
      prevalue: 'Onset',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-19-1-VIR-NEW',
      depending: 'PP5-19-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-19-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.19.2',
      extend: 'true',
      shortname: 'pp5-19-2-vir-new',
      name: '',
      prevalue: 'Duration',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-19-2-VIR-NEW',
      depending: 'PP5-19-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-20-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.20',
      shortname: 'pp5-20-vir-new',
      name: '',
      prevalue: 'Guilt',
      value: [false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact'],
      act: 'PP5-20-VIR-NEW',
      depending: '',
      exception: '',
      link: 'PP5-20-1-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.20.1',
      extend: 'true',
      shortname: 'pp5-20-1-vir-new',
      name: '',
      prevalue: 'Onset',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-20-1-VIR-NEW',
      depending: 'PP5-20-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-20-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.20.2',
      extend: 'true',
      shortname: 'pp5-20-2-vir-new',
      name: '',
      prevalue: 'Duration',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-20-2-VIR-NEW',
      depending: 'PP5-20-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-21-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.21',
      shortname: 'pp5-21-vir-new',
      name: '',
      prevalue: 'Hallucinations',
      value: [false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact'],
      act: 'PP5-21-VIR-NEW',
      depending: '',
      exception: '',
      link: 'PP5-21-1-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.21.1',
      extend: 'true',
      shortname: 'pp5-21-1-vir-new',
      name: '',
      prevalue: 'Onset',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-21-1-VIR-NEW',
      depending: 'PP5-21-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-21-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.21.2',
      extend: 'true',
      shortname: 'pp5-21-2-vir-new',
      name: '',
      prevalue: 'Duration',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-21-2-VIR-NEW',
      depending: 'PP5-21-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-22-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.22',
      shortname: 'pp5-22-vir-new',
      name: '',
      prevalue: 'Hopelessness',
      value: [false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact'],
      act: 'PP5-22-VIR-NEW',
      depending: '',
      exception: '',
      link: 'PP5-22-1-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.22.1',
      extend: 'true',
      shortname: 'pp5-22-1-vir-new',
      name: '',
      prevalue: 'Onset',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-22-1-VIR-NEW',
      depending: 'PP5-22-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-22-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.22.2',
      extend: 'true',
      shortname: 'pp5-22-2-vir-new',
      name: '',
      prevalue: 'Duration',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-22-2-VIR-NEW',
      depending: 'PP5-22-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-23-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.23',
      shortname: 'pp5-23-vir-new',
      name: '',
      prevalue: 'Hyperactivity',
      value: [false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact'],
      act: 'PP5-23-VIR-NEW',
      depending: '',
      exception: '',
      link: 'PP5-23-1-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.23.1',
      extend: 'true',
      shortname: 'pp5-23-1-vir-new',
      name: '',
      prevalue: 'Onset',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-23-1-VIR-NEW',
      depending: 'PP5-23-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-23-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.23.2',
      extend: 'true',
      shortname: 'pp5-23-2-vir-new',
      name: '',
      prevalue: 'Duration',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-23-2-VIR-NEW',
      depending: 'PP5-23-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-24-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.24',
      shortname: 'pp5-24-vir-new',
      name: '',
      prevalue: 'Irritability',
      value: [false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact'],
      act: 'PP5-24-VIR-NEW',
      depending: '',
      exception: '',
      link: 'PP5-24-1-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.24.1',
      extend: 'true',
      shortname: 'pp5-24-1-vir-new',
      name: '',
      prevalue: 'Onset',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-24-1-VIR-NEW',
      depending: 'PP5-24-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-24-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.24.2',
      extend: 'true',
      shortname: 'pp5-24-2-vir-new',
      name: '',
      prevalue: 'Duration',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-24-2-VIR-NEW',
      depending: 'PP5-24-VIR-NEW',
      exception: 'Impact',
      // link: 'PP5-25-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-1',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },



    {
      id: 'PP.5.25',
      shortname: 'pp5-25-vir-new',
      name: '',
      prevalue: 'Laxative/Diuretic Abuse',
      value: [false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact'],
      act: 'PP5-25-VIR-NEW',
      depending: '',
      exception: '',
      link: 'PP5-25-1-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.25.1',
      extend: 'true',
      shortname: 'pp5-25-1-vir-new',
      name: '',
      prevalue: 'Onset',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-25-1-VIR-NEW',
      depending: 'PP5-25-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-25-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.25.2',
      extend: 'true',
      shortname: 'pp5-25-2-vir-new',
      name: '',
      prevalue: 'Duration',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-25-2-VIR-NEW',
      depending: 'PP5-25-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-26-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.26',
      shortname: 'pp5-26-vir-new',
      name: '',
      prevalue: 'Loose Associations',
      value: [false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact'],
      act: 'PP5-26-VIR-NEW',
      depending: '',
      exception: '',
      link: 'PP5-26-1-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.26.1',
      extend: 'true',
      shortname: 'pp5-26-1-vir-new',
      name: '',
      prevalue: 'Onset',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-26-1-VIR-NEW',
      depending: 'PP5-26-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-26-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.26.2',
      extend: 'true',
      shortname: 'pp5-26-2-vir-new',
      name: '',
      prevalue: 'Duration',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-26-2-VIR-NEW',
      depending: 'PP5-26-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-27-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.27',
      shortname: 'pp5-27-vir-new',
      name: '',
      prevalue: 'Mood Swings',
      value: [false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact'],
      act: 'PP5-27-VIR-NEW',
      depending: '',
      exception: '',
      link: 'PP5-27-1-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.27.1',
      extend: 'true',
      shortname: 'pp5-27-1-vir-new',
      name: '',
      prevalue: 'Onset',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-27-1-VIR-NEW',
      depending: 'PP5-27-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-27-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.27.2',
      extend: 'true',
      shortname: 'pp5-27-2-vir-new',
      name: '',
      prevalue: 'Duration',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-27-2-VIR-NEW',
      depending: 'PP5-27-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-28-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.28',
      shortname: 'pp5-28-vir-new',
      name: '',
      prevalue: 'Obsessions/Compulsions',
      value: [false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact'],
      act: 'PP5-28-VIR-NEW',
      depending: '',
      exception: '',
      link: 'PP5-28-1-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.28.1',
      extend: 'true',
      shortname: 'pp5-28-1-vir-new',
      name: '',
      prevalue: 'Onset',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-28-1-VIR-NEW',
      depending: 'PP5-28-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-28-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.28.2',
      extend: 'true',
      shortname: 'pp5-28-2-vir-new',
      name: '',
      prevalue: 'Duration',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-28-2-VIR-NEW',
      depending: 'PP5-28-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-29-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.29',
      shortname: 'pp5-29-vir-new',
      name: '',
      prevalue: 'Oppositional Behavior',
      value: [false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact'],
      act: 'PP5-29-VIR-NEW',
      depending: '',
      exception: '',
      link: 'PP5-29-1-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.29.1',
      extend: 'true',
      shortname: 'pp5-29-1-vir-new',
      name: '',
      prevalue: 'Onset',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-29-1-VIR-NEW',
      depending: 'PP5-29-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-29-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.29.2',
      extend: 'true',
      shortname: 'pp5-29-2-vir-new',
      name: '',
      prevalue: 'Duration',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-29-2-VIR-NEW',
      depending: 'PP5-29-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-30-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.30',
      shortname: 'pp5-30-vir-new',
      name: '',
      prevalue: 'Panic Attacks',
      value: [false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact'],
      act: 'PP5-30-VIR-NEW',
      depending: '',
      exception: '',
      link: 'PP5-30-1-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.30.1',
      extend: 'true',
      shortname: 'pp5-30-1-vir-new',
      name: '',
      prevalue: 'Onset',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-30-1-VIR-NEW',
      depending: 'PP5-30-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-30-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.30.2',
      extend: 'true',
      shortname: 'pp5-30-2-vir-new',
      name: '',
      prevalue: 'Duration',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-30-2-VIR-NEW',
      depending: 'PP5-30-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-31-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.31',
      shortname: 'pp5-31-vir-new',
      name: '',
      prevalue: 'Paranoid Ideation',
      value: [false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact'],
      act: 'PP5-31-VIR-NEW',
      depending: '',
      exception: '',
      link: 'PP5-31-1-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.31.1',
      extend: 'true',
      shortname: 'pp5-31-1-vir-new',
      name: '',
      prevalue: 'Onset',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-31-1-VIR-NEW',
      depending: 'PP5-31-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-31-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.31.2',
      extend: 'true',
      shortname: 'pp5-31-2-vir-new',
      name: '',
      prevalue: 'Duration',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-31-2-VIR-NEW',
      depending: 'PP5-31-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-32-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.32',
      shortname: 'pp5-32-vir-new',
      name: '',
      prevalue: 'Phobias',
      value: [false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact'],
      act: 'PP5-32-VIR-NEW',
      depending: '',
      exception: '',
      link: 'PP5-32-1-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.32.1',
      extend: 'true',
      shortname: 'pp5-32-1-vir-new',
      name: '',
      prevalue: 'Onset',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-32-1-VIR-NEW',
      depending: 'PP5-32-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-32-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.32.2',
      extend: 'true',
      shortname: 'pp5-32-2-vir-new',
      name: '',
      prevalue: 'Duration',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-32-2-VIR-NEW',
      depending: 'PP5-32-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-33-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.33',
      shortname: 'pp5-33-vir-new',
      name: '',
      prevalue: 'Physical Trauma-(Perpetrator)',
      value: [false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact'],
      act: 'PP5-33-VIR-NEW',
      depending: '',
      exception: '',
      link: 'PP5-33-1-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.33.1',
      extend: 'true',
      shortname: 'pp5-33-1-vir-new',
      name: '',
      prevalue: 'Onset',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-33-1-VIR-NEW',
      depending: 'PP5-33-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-33-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.33.2',
      extend: 'true',
      shortname: 'pp5-33-2-vir-new',
      name: '',
      prevalue: 'Duration',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-33-2-VIR-NEW',
      depending: 'PP5-33-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-34-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.34',
      shortname: 'pp5-34-vir-new',
      name: '',
      prevalue: 'Physical Trauma-(Victim)',
      value: [false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact'],
      act: 'PP5-34-VIR-NEW',
      depending: '',
      exception: '',
      link: 'PP5-34-1-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.34.1',
      extend: 'true',
      shortname: 'pp5-34-1-vir-new',
      name: '',
      prevalue: 'Onset',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-34-1-VIR-NEW',
      depending: 'PP5-34-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-34-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.34.2',
      extend: 'true',
      shortname: 'pp5-34-2-vir-new',
      name: '',
      prevalue: 'Duration',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-34-2-VIR-NEW',
      depending: 'PP5-34-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-35-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.35',
      shortname: 'pp5-35-vir-new',
      name: '',
      prevalue: 'Poor Concentration',
      value: [false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact'],
      act: 'PP5-35-VIR-NEW',
      depending: '',
      exception: '',
      link: 'PP5-35-1-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.35.1',
      extend: 'true',
      shortname: 'pp5-35-1-vir-new',
      name: '',
      prevalue: 'Onset',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-35-1-VIR-NEW',
      depending: 'PP5-35-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-35-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.35.2',
      extend: 'true',
      shortname: 'pp5-35-2-vir-new',
      name: '',
      prevalue: 'Duration',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-35-2-VIR-NEW',
      depending: 'PP5-35-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-36-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.36',
      shortname: 'pp5-36-vir-new',
      name: '',
      prevalue: 'Poor Grooming',
      value: [false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact'],
      act: 'PP5-36-VIR-NEW',
      depending: '',
      exception: '',
      link: 'PP5-36-1-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.36.1',
      extend: 'true',
      shortname: 'pp5-36-1-vir-new',
      name: '',
      prevalue: 'Onset',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-36-1-VIR-NEW',
      depending: 'PP5-36-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-36-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.36.2',
      extend: 'true',
      shortname: 'pp5-36-2-vir-new',
      name: '',
      prevalue: 'Duration',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-36-2-VIR-NEW',
      depending: 'PP5-36-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-37-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.37',
      shortname: 'pp5-37-vir-new',
      name: '',
      prevalue: 'Psychomotor Retardation',
      value: [false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact'],
      act: 'PP5-37-VIR-NEW',
      depending: '',
      exception: '',
      link: 'PP5-37-1-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.37.1',
      extend: 'true',
      shortname: 'pp5-37-1-vir-new',
      name: '',
      prevalue: 'Onset',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-37-1-VIR-NEW',
      depending: 'PP5-37-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-37-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.37.2',
      extend: 'true',
      shortname: 'pp5-37-2-vir-new',
      name: '',
      prevalue: 'Duration',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-37-2-VIR-NEW',
      depending: 'PP5-37-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-38-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.38',
      shortname: 'pp5-38-vir-new',
      name: '',
      prevalue: 'Self-Mutilation',
      value: [false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact'],
      act: 'PP5-38-VIR-NEW',
      depending: '',
      exception: '',
      link: 'PP5-38-1-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.38.1',
      extend: 'true',
      shortname: 'pp5-38-1-vir-new',
      name: '',
      prevalue: 'Onset',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-38-1-VIR-NEW',
      depending: 'PP5-38-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-38-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.38.2',
      extend: 'true',
      shortname: 'pp5-38-2-vir-new',
      name: '',
      prevalue: 'Duration',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-38-2-VIR-NEW',
      depending: 'PP5-38-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-39-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.39',
      shortname: 'pp5-39-vir-new',
      name: '',
      prevalue: 'Sexual Dysfunction',
      value: [false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact'],
      act: 'PP5-39-VIR-NEW',
      depending: '',
      exception: '',
      link: 'PP5-39-1-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.39.1',
      extend: 'true',
      shortname: 'pp5-39-1-vir-new',
      name: '',
      prevalue: 'Onset',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-39-1-VIR-NEW',
      depending: 'PP5-39-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-39-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.39.2',
      extend: 'true',
      shortname: 'pp5-39-2-vir-new',
      name: '',
      prevalue: 'Duration',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-39-2-VIR-NEW',
      depending: 'PP5-39-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-40-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.40',
      shortname: 'pp5-40-vir-new',
      name: '',
      prevalue: 'Sexual Trauma-(Perpetrator)',
      value: [false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact'],
      act: 'PP5-40-VIR-NEW',
      depending: '',
      exception: '',
      link: 'PP5-40-1-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.40.1',
      extend: 'true',
      shortname: 'pp5-40-1-vir-new',
      name: '',
      prevalue: 'Onset',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-40-1-VIR-NEW',
      depending: 'PP5-40-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-40-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.40.2',
      extend: 'true',
      shortname: 'pp5-40-2-vir-new',
      name: '',
      prevalue: 'Duration',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-40-2-VIR-NEW',
      depending: 'PP5-40-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-41-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.41',
      shortname: 'pp5-41-vir-new',
      name: '',
      prevalue: 'Sexual Trauma-(Victim)',
      value: [false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact'],
      act: 'PP5-41-VIR-NEW',
      depending: '',
      exception: '',
      link: 'PP5-41-1-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.41.1',
      extend: 'true',
      shortname: 'pp5-41-1-vir-new',
      name: '',
      prevalue: 'Onset',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-41-1-VIR-NEW',
      depending: 'PP5-41-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-41-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.41.2',
      extend: 'true',
      shortname: 'pp5-41-2-vir-new',
      name: '',
      prevalue: 'Duration',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-41-2-VIR-NEW',
      depending: 'PP5-41-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-42-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.42',
      shortname: 'pp5-42-vir-new',
      name: '',
      prevalue: 'Significant Weight Gain/Loss',
      value: [false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact'],
      act: 'PP5-42-VIR-NEW',
      depending: '',
      exception: '',
      link: 'PP5-42-1-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.42.1',
      extend: 'true',
      shortname: 'pp5-42-1-vir-new',
      name: '',
      prevalue: 'Onset',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-42-1-VIR-NEW',
      depending: 'PP5-42-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-42-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.42.2',
      extend: 'true',
      shortname: 'pp5-42-2-vir-new',
      name: '',
      prevalue: 'Duration',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-42-2-VIR-NEW',
      depending: 'PP5-42-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-43-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.43',
      shortname: 'pp5-43-vir-new',
      name: '',
      prevalue: 'Sleep Disturbance',
      value: [false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact'],
      act: 'PP5-43-VIR-NEW',
      depending: '',
      exception: '',
      link: 'PP5-43-1-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.43.1',
      extend: 'true',
      shortname: 'pp5-43-1-vir-new',
      name: '',
      prevalue: 'Onset',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-43-1-VIR-NEW',
      depending: 'PP5-43-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-43-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.43.2',
      extend: 'true',
      shortname: 'pp5-43-2-vir-new',
      name: '',
      prevalue: 'Duration',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-43-2-VIR-NEW',
      depending: 'PP5-43-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-44-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.44',
      shortname: 'pp5-44-vir-new',
      name: '',
      prevalue: 'Social Isolation',
      value: [false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact'],
      act: 'PP5-44-VIR-NEW',
      depending: '',
      exception: '',
      link: 'PP5-44-1-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.44.1',
      extend: 'true',
      shortname: 'pp5-44-1-vir-new',
      name: '',
      prevalue: 'Onset',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-44-1-VIR-NEW',
      depending: 'PP5-44-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-44-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.44.2',
      extend: 'true',
      shortname: 'pp5-44-2-vir-new',
      name: '',
      prevalue: 'Duration',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-44-2-VIR-NEW',
      depending: 'PP5-44-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-45-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.45',
      shortname: 'pp5-45-vir-new',
      name: '',
      prevalue: 'Somatic Complaints',
      value: [false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact'],
      act: 'PP5-45-VIR-NEW',
      depending: '',
      exception: '',
      link: 'PP5-45-1-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.45.1',
      extend: 'true',
      shortname: 'pp5-45-1-vir-new',
      name: '',
      prevalue: 'Onset',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-45-1-VIR-NEW',
      depending: 'PP5-45-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-45-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.45.2',
      extend: 'true',
      shortname: 'pp5-45-2-vir-new',
      name: '',
      prevalue: 'Duration',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-45-2-VIR-NEW',
      depending: 'PP5-45-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-46-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.46',
      shortname: 'pp5-46-vir-new',
      name: '',
      prevalue: 'Substance Abuse',
      value: [false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact'],
      act: 'PP5-46-VIR-NEW',
      depending: '',
      exception: '',
      link: 'PP5-46-1-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.46.1',
      extend: 'true',
      shortname: 'pp5-46-1-vir-new',
      name: '',
      prevalue: 'Onset',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-46-1-VIR-NEW',
      depending: 'PP5-46-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-46-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.46.2',
      extend: 'true',
      shortname: 'pp5-46-2-vir-new',
      name: '',
      prevalue: 'Duration',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-46-2-VIR-NEW',
      depending: 'PP5-46-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-47-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.47',
      shortname: 'pp5-47-vir-new',
      name: '',
      prevalue: 'Worthlessness',
      value: [false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact'],
      act: 'PP5-47-VIR-NEW',
      depending: '',
      exception: '',
      link: 'PP5-47-1-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.47.1',
      extend: 'true',
      shortname: 'pp5-47-1-vir-new',
      name: '',
      prevalue: 'Onset',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-47-1-VIR-NEW',
      depending: 'PP5-47-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-47-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.47.2',
      extend: 'true',
      shortname: 'pp5-47-2-vir-new',
      name: '',
      prevalue: 'Duration',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-47-2-VIR-NEW',
      depending: 'PP5-47-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-48-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.48',
      shortname: 'pp5-48-vir-new',
      name: '',
      prevalue: 'Other',
      value: [false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact'],
      act: 'PP5-48-VIR-NEW',
      depending: '',
      exception: '',
      link: 'PP5-48-OTHER-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.48.OTHER',
      extend: 'true',
      shortname: 'pp5-48-other-vir-new',
      name: '',
      prevalue: 'Please explain:',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-48-OTHER-VIR-NEW',
      depending: 'PP5-48-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-48-1-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.48.1',
      extend: 'true',
      shortname: 'pp5-48-1-vir-new',
      name: '',
      prevalue: 'Onset',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-48-1-VIR-NEW',
      depending: 'PP5-48-VIR-NEW',
      exception: 'Impact',
      link: 'PP5-48-2-VIR-NEW',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    {
      id: 'PP.5.48.2',
      extend: 'true',
      shortname: 'pp5-48-2-vir-new',
      name: '',
      prevalue: 'Duration',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PP5-48-2-VIR-NEW',
      depending: 'PP5-48-VIR-NEW',
      exception: 'Impact',
      subtopic_container_act: 'PP5-VIR-NEW',
      suptopic_code: 'PP5-VIR-NEW-SEC-2',
      subtopic_name: 'Onset = Age in which symptoms began. Duration = How Long the symptoms have lasted',
    },
    //======================================================
    {
      id: 'PP.6',
      shortname: 'pp8-vir',
      mandatory: 'true',
      name: 'Presenting Issue(s)/Reason for Referral/Chief Complaint: Indicate duration, frequency and severity of behavioral health symptoms. Identify precipitating events/stressors and relevant history.',
      prevalue: '',
      value: '',
      disabled: 'false',
      type: 'editor',
      act: 'PP8-VIR',
      depending: '',
      exception: '',
    },
    {
      id: 'PP.7',
      shortname: 'pr9-vir',
      name: 'Presenting Issue(s)/Reason for Referral/Chief Complaint',
      prevalue: 'If this is a child, is the child at risk of an out oh home placement?',
      value: '',
      disabled: 'false',
      type: 'radio',
      radio_options: ['Yes', 'No', 'Not a child'],
      act: 'PR9-VIR',
      depending: '',
      exception: '',
      link: 'PR9-ADD-VIR',
    },
    {
      id: 'PP.7.1',
      shortname: 'pr9-add-vir',
      name: '',
      prevalue: 'State the specific reason and what the out of home placement may be.',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'PR9-ADD-VIR',
      depending: 'PR9-VIR',
      exception: 'Yes',
      extend: 'true',
    },
  ],
};

export default presentingProblemJSON;
